// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"SavedBusinesses_modalOverlay__1BGz7","modalContent":"SavedBusinesses_modalContent__oKRTS","closeButton":"SavedBusinesses_closeButton__3M97F"};